import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showToastMessage } from "../../helpers/toastr";
import ReactLogo from "../../assets/images/salonbill1.png";
import { handleRegister } from "../../services/getLoggedUserData.js";
import { validatePhone } from "../../helpers/validatePhone.js";

export const Register = () => {
    const [btn, setBtn] = useState(false);
    const [showRegisterForm, setShowRegisterForm] = useState(true);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const [registerData, setRegisterData] = useState({
        name: "",
        email: "",
        phone_number: "",
        password: "",
        gst_number: "",
        address: "",
        legal_name: "",
        organisation_name: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setRegisterData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!registerData.name.trim()) {
            newErrors.name = "Name is required";
            isValid = false;
        }
        if (!registerData.legal_name.trim()) {
            newErrors.legal_name = "Legal Name is required";
            isValid = false;
        }
        if (!registerData.organisation_name.trim()) {
            newErrors.organisation_name = "Outlet name is required";
            isValid = false;
        }
        if (!registerData.email.trim()) {
            newErrors.email = "Email is required";
            isValid = false;
        } else if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(registerData.email.trim())) {
            newErrors.email = "Please enter a valid email address";
            isValid = false;
        }
        if (!registerData.phone_number.trim()) {
            newErrors.phone_number = "Mobile number is required";
            isValid = false;
        } else if (!/^\d{10}$/.test(registerData.phone_number.trim())) {
            newErrors.phone_number = "Please enter a valid mobile number";
            isValid = false;
        }
        if (!registerData.password.trim()) {
            newErrors.password = "Password is required";
            isValid = false;
        } else if (registerData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
            isValid = false;
        }
        if (!registerData.address.trim()) {
            newErrors.address = "Address is required";
            isValid = false;
        }
        if (!registerData.gst_number.trim()) {
            newErrors.gst_number = "GST Number is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const registerUser = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setBtn(true);
            try {
                await handleRegister(registerData);
                setBtn(false);
                showToastMessage("success", "Registration successful! Please check your email to verify your account.");

                setShowRegisterForm(false);
                navigate("/login");
            } catch (error) {
                setBtn(false);

                // Check if the error response contains field-specific validation errors
                if (error.response?.data?.message && typeof error.response.data.message === 'object') {
                    // Update errors state with the field-specific errors from the API
                    setErrors(prevErrors => ({
                        ...prevErrors,
                        ...error.response.data.message
                    }));

                    // Show a general error toast
                    showToastMessage("error", "Please correct the errors in the form.");
                } else {
                    // Show a general error message if no specific validation errors
                    const errorMessage = error.response?.data?.message || error.message || "An unexpected error occurred during registration.";
                    showToastMessage("error", errorMessage);
                }
            }
        }
    };

    const toggleRegisterForm = () => {
        setShowRegisterForm(!showRegisterForm);
    };

    return (
        <div className="container-scroller">
            <div className="container-fluid page-body-wrapper full-page-wrapper">
                <div className="content-wrapper auth">
                    <div className="auth-content">
                        <div className="left-img"></div>
                        <div className="auth-form-light">
                            <div className="auth-form-content">
                                <div className="brand-logo">
                                    <img src={ReactLogo} alt="logo" className="w-100" style={{ maxWidth: "250px" }} />
                                </div>
                                <div>
                                    <h1>Create Account</h1>
                                    <h4>Sign up to get started</h4>
                                    <form className="auth-form" onSubmit={registerUser}>
                                        <div className="form-group">
                                            <label>Full Name</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                value={registerData.name}
                                                onChange={handleInputChange}
                                                name="name"
                                                placeholder="Enter your full name"
                                            />
                                            {errors.name && <div className="text-danger">{errors.name}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label>Email Address</label>
                                            <input
                                                type="email"
                                                className="form-control form-control-lg"
                                                value={registerData.email}
                                                onChange={handleInputChange}
                                                name="email"
                                                placeholder="Enter your email"
                                            />
                                            {errors.email && <div className="text-danger">{errors.email}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label>Mobile Number</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                value={registerData.phone_number}
                                                onKeyDown={validatePhone}
                                                onChange={handleInputChange}
                                                name="phone_number"
                                                placeholder="Enter mobile number"
                                            />
                                            {errors.phone_number && <div className="text-danger">{errors.phone_number}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label>Password</label>
                                            <input
                                                type="password"
                                                className="form-control form-control-lg"
                                                value={registerData.password}
                                                onChange={handleInputChange}
                                                name="password"
                                                placeholder="Create password"
                                            />
                                            {errors.password && <div className="text-danger">{errors.password}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label>Organisation Name</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                value={registerData.organisation_name}
                                                onChange={handleInputChange}
                                                name="organisation_name"
                                                placeholder="Enter organisation name"
                                            />
                                            {errors.organisation_name && <div className="text-danger">{errors.organisation_name}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label>Address</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                value={registerData.address}
                                                onChange={handleInputChange}
                                                name="address"
                                                placeholder="Enter address"
                                            />
                                            {errors.address && <div className="text-danger">{errors.address}</div>}
                                        </div>

                                        <div className="form-group">
                                            <label>Legal Name</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                value={registerData.legal_name}
                                                onChange={handleInputChange}
                                                name="legal_name"
                                                placeholder="Enter legal name"
                                            />
                                            {errors.legal_name && <div className="text-danger">{errors.legal_name}</div>}
                                        </div>
                                        <div className="form-group">
                                            <label>GST Number</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                value={registerData.gst_number}
                                                onChange={handleInputChange}
                                                name="gst_number"
                                                placeholder="Enter GST number"
                                            />
                                            {errors.gst_number && <div className="text-danger">{errors.gst_number}</div>}
                                        </div>

                                        <div className="mt-3">
                                            <button
                                                type="submit"
                                                disabled={btn}
                                                className="btn btn-block btn-gradient-danger btn-lg font-weight-medium auth-form-btn w-100"
                                            >
                                                {btn ? "Processing..." : "Register"}
                                            </button>
                                        </div>
                                    </form>
                                    <div className="my-2 d-flex justify-content-center">
                                        <div onClick={() => navigate('/')} className="auth-link text-black cursor-pointer">
                                            Already have an account? Sign in
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
